import { render, staticRenderFns } from "./TasinmazEkleForm.vue?vue&type=template&id=92b6268c"
import script from "./TasinmazEkleForm.vue?vue&type=script&lang=ts"
export * from "./TasinmazEkleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports